"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleName = void 0;
var LocaleName;
(function (LocaleName) {
    LocaleName["cs"] = "cs";
    LocaleName["en"] = "en";
    LocaleName["de"] = "de";
    LocaleName["sk"] = "sk";
})(LocaleName = exports.LocaleName || (exports.LocaleName = {}));
//# sourceMappingURL=locale-types.js.map